import { User } from '../auth/User';
import { CreateFeatureFlagPayload, FeatureFlag } from '../types/FeatureFlag';
import { ApiRoutes, constructApiParams, getFullApiRoute } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export class FeatureFlagAPI {
  static async getAll(user: User, page = 1, limit = 100): Promise<FeatureFlag[]> {
    const url = constructApiParams(
      getFullApiRoute(ApiRoutes.FEATURE_FLAG),
      { page, per_page: limit },
      true,
    );
    const result = await HttpRequest(url, 'GET', null, null, user);
    return result?.data || [];
  }

  static async getOne(user: User, id: string): Promise<FeatureFlag | undefined> {
    const result = await HttpRequest(
      `${getFullApiRoute(ApiRoutes.FEATURE_FLAG)}/${id}`,
      'GET',
      null,
      null,
      user,
    );
    return result?.data;
  }

  static async create(
    user: User,
    data: CreateFeatureFlagPayload,
  ): Promise<FeatureFlag | undefined> {
    const result = await HttpRequest(
      getFullApiRoute(ApiRoutes.FEATURE_FLAG),
      'POST',
      data,
      new Headers({ 'Content-Type': 'application/json' }),
      user,
    );
    return result?.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : undefined;
  }

  static async update(
    user: User,
    id: string,
    data: CreateFeatureFlagPayload,
  ): Promise<FeatureFlag | undefined> {
    const result = await HttpRequest(
      `${getFullApiRoute(ApiRoutes.FEATURE_FLAG)}/${id}`,
      'PUT',
      data,
      new Headers({ 'Content-Type': 'application/json' }),
      user,
    );
    return result?.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : undefined;
  }

  static async deleteOne(user: User, id: string): Promise<boolean> {
    await HttpRequest(
      `${getFullApiRoute(ApiRoutes.FEATURE_FLAG)}/${id}`,
      'DELETE',
      null,
      null,
      user,
    );
    return true;
  }
}
